import React from "react";
import { motion } from "framer-motion";
import loaderGif from "../assets/images/supply-spot-loader.gif";

export default function Preloader() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-bg-primary text-text-primary select-none pointer-events-auto"
    >
      {/* Background Cyber Grid overlay to match landing page look */}
      <div className="absolute inset-0 bg-grid-pattern-50 opacity-[0.03] pointer-events-none" />

      {/* Glow effect behind loader */}
      <div className="absolute w-[220px] h-[220px] bg-brand-orange/10 rounded-full blur-[80px] animate-pulse" />

      <div className="relative flex flex-col items-center gap-6">
        {/* GIF container with brand border & glow */}
        <div className="w-28 h-28 rounded-full overflow-hidden border-2 border-brand-orange/25 shadow-glow-orange flex items-center justify-center bg-bg-secondary/40 p-2 backdrop-blur-sm">
          <img 
            src={loaderGif} 
            alt="Supply Spot Loading..." 
            className="w-full h-full object-contain scale-[1.1]"
          />
        </div>
        
        {/* Brand Text & Status */}
        <div className="flex flex-col items-center gap-1.5 text-center">
          <h3 className="text-xs font-bold tracking-[0.2em] font-title uppercase text-brand-orange drop-shadow-md">
            SUPPLY SPOT
          </h3>
          <span className="text-[9px] font-bold text-text-muted tracking-widest uppercase animate-pulse">
            Connecting Operations...
          </span>
        </div>
      </div>
    </motion.div>
  );
}
